export default __webpack_public_path__ + "d7fdd2d1811be4d6da37516db965176d.png";